import {Asset} from "../../../feature/project/fields";
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {Button, Col, Divider, Flex, Image, Row, Space, Tooltip} from "antd";
import React, {useEffect} from "react";
import {fetchLore} from "../../../feature/project/loreSlice";
import {useParams} from "react-router-dom";
import lore from "../../story/Lore";
import {Component} from "../../../feature/project/setting";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faFile, faMusic, faTrash} from "@fortawesome/free-solid-svg-icons";
import {fetchStorySetting} from "../../../feature/project/settingsSlice";
import {audioFormats, imageFormats} from "../../common/FilesBrowser";

export const AssetsBrowser = (props: { categories: string[], onAssetSelected: (asset: Asset | null) => void }) => {
    const lores = useAppSelector(state => state.settings.storySetting?.components?.filter(item => props.categories.includes(item.category?.title ?? ''))) ?? []
    const assets = useAppSelector(state => state.settings.storySetting?.components?.map(component => component.assets ?? []).flat() ?? [])
    const {projectId} = useParams()
    const dispatch = useAppDispatch()
    const settingId = useAppSelector(state => state.stories.story?.settingId)
    const [component, setComponent] = React.useState<Component | undefined>(undefined)
    useEffect(() => {
            if (projectId && settingId) {
                dispatch(fetchStorySetting({projectId: parseInt(projectId), settingId: settingId}))
            }
        }, [settingId, projectId]
    );
    return (
        <>
            {component ?
                <div>
                    <Space direction={'vertical'}>
                        <Space>
                            <Button icon={<FontAwesomeIcon icon={faArrowLeft}/>}
                                    onClick={() => setComponent(undefined)}/>
                            Assets
                        </Space>
                        <Divider style={{marginTop: 0, marginBottom: 0, marginLeft: -12, width: 'calc(100% + 24px)'}}/>
                        <Flex gap={16}>
                            <Space direction={'vertical'}
                                   style={{width: '360px', maxHeight: 340, overflowY: 'auto', scrollbarWidth: "none"}}
                                   size={16}>
                                <Row gutter={[8, 8]}>
                                    {component.assets?.filter(c => imageFormats.includes(c.content?.split(".")?.pop() ?? "") || audioFormats.includes(c.content?.split(".")?.pop() ?? "")).map((element, index) =>
                                        <Col span={8}
                                             onClick={() => {
                                                 props.onAssetSelected(element)
                                                 setComponent(undefined)
                                             }}
                                             key={index}
                                        >
                                            {(element.content?.endsWith('.mp3')) ?
                                                <Tooltip title={element.content?.split("/").pop()}><Flex style={{
                                                    height: "100%",
                                                    aspectRatio: 1,
                                                    justifyContent: 'center',
                                                    background: "#eee",
                                                    borderRadius: 6
                                                }} align={'center'}><FontAwesomeIcon icon={faMusic}
                                                                                     size={'2xl'}/></Flex></Tooltip> :
                                                (element.content?.endsWith('.json')) ?
                                                    <FontAwesomeIcon icon={faFile} size={'2xl'}/> :
                                                    <Image src={element.content} preview={false}
                                                           style={{borderRadius: 6}}/>}
                                        </Col>
                                    )}
                                </Row>
                            </Space>
                        </Flex>
                    </Space>
                </div>
                :
                <div>
                    <Space direction={'vertical'}>
                        <Flex align={'center'} justify={'space-between'}>
                            Lore Components
                            <Button icon={<FontAwesomeIcon icon={faTrash}/>}
                                    onClick={() => props.onAssetSelected(null)}/>

                        </Flex>
                        <Divider style={{marginTop: 0, marginBottom: 0, marginLeft: -12, width: 'calc(100% + 24px)'}}/>

                        <Flex gap={16}>
                            <Space direction={'vertical'}
                                   style={{width: '360px', maxHeight: 340, overflowY: 'auto', scrollbarWidth: "none"}}
                                   size={16}>
                                <Row gutter={[8, 8]}>
                                    {lores?.map((element, index) =>
                                        <Col span={8}
                                             onClick={() => {
                                                 setComponent(element)
                                             }}
                                             key={index}
                                        >
                                            <Image src={element.cover} preview={false} style={{borderRadius: 6}}/>
                                        </Col>
                                    )}
                                </Row>
                            </Space>
                        </Flex>
                    </Space>
                </div>
            }
        </>
    )
}